
export class createEditSubscriberModel {

  public subscriberID: number;
  public userId: number;
  public companyID: number;
  public name: string;
  public lastName: string;
  public carNo: string;
  public carNo2: string;
  public startDate: string;
  public endDate: string;
  public isReservedPlace: boolean;
  public reservedParkID: number;
  public phone: string;
  public destinedPark: number;

  constructor() {

  }

}


export class convertResidentToSubscriberModel {

  public newCompanyID: number;
  public userId: number;

  public carNo: string;

  public isReservedPlace: boolean;
  public reservedParkID: number;
  public phone: string;
  public destinedPark: number;

  constructor() {

  }

}
